<template>
<div :ref="loadingobj">
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">系统菜单总览<i>（非技术请勿操作）</i></span>
        <div class="TTL-button TTL-btn-option" v-if="rootMenu">
            <wcbutton :option="{title:'新增一级菜单'}" @finish="addmeu(rootMenu)" />
        </div>
    </div>

    <div class="TTL-form-submit-box">
        <div class="permission-tree" v-if="rootMenu">
            <div class="tree-level-1" v-for="(level1, index1) in rootChildren" :key="'l1-'+level1.id+'-'+index1">
                <div class="level-1-header">
                    <div class="menu-row">
                        <div class="menu-row-main">
                            <span class="level-1-name">{{ level1.name }}<i v-if="isPaid(level1)">{{ paidText(level1) }}</i></span>
                        </div>
                        <div class="icon-box">
                            <div class="icon add" @click.stop="addmeu(level1)" />
                            <div class="icon edit" @click.stop="editmenus(level1)" />
                            <div class="icon del" @click.stop="delmenus(level1)" />
                        </div>
                    </div>
                </div>

                <div class="tree-level-2-wrapper" v-if="childList(level1).length">
                    <div class="tree-level-2" v-for="(level2, index2) in childList(level1)" :key="'l2-'+level2.id+'-'+index2">
                        <div class="level-2-header">
                            <div class="menu-row">
                                <span class="level-2-name">{{ level2.name }}<i v-if="isPaid(level2)">{{ paidText(level2) }}</i></span>
                                <div class="icon-box">
                                    <div class="icon add" @click.stop="addmeu(level2)" />
                                    <div class="icon edit" @click.stop="editmenus(level2)" />
                                    <div class="icon del" @click.stop="delmenus(level2)" />
                                </div>
                            </div>
                        </div>

                        <div class="tree-level-3" v-if="childList(level2).length">
                            <div class="level-3-item" v-for="(level3, index3) in childList(level2)" :key="'l3-'+level3.id+'-'+index3">
                                <div class="level-3-main">
                                    <span class="level-3-name">{{ level3.name }}<i v-if="isPaid(level3)">{{ paidText(level3) }}</i></span>
                                    <div class="icon-box">
                                        <div class="icon edit" @click.stop="editmenus(level3)" />
                                        <div class="icon del" @click.stop="delmenus(level3)" />
                                    </div>
                                </div>
                                <div class="tree-level-4" v-if="childList(level3).length">
                                    <div class="level-4-item" v-for="(level4, index4) in childList(level3)" :key="'l4-'+level4.id+'-'+index4">
                                        <span class="level-4-name">{{ level4.name }}<i v-if="isPaid(level4)">{{ paidText(level4) }}</i></span>
                                        <div class="icon-box">
                                            <div class="icon edit" @click.stop="editmenus(level4)" />
                                            <div class="icon del" @click.stop="delmenus(level4)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-empty v-else description="暂无菜单数据" />
    </div>

    <el-dialog v-model="param.show" :title="param.id ? '编辑菜单' : '新增菜单'" width="30%" top="5vh" :close-on-click-modal="false">
        <div>
            <div class="TTL-form-submit-box">
                <el-form :inline="false">
                    <el-form-item>
                        <label class="TTL-form-label">组件icon名称</label>
                        <div class="TTL-input width300 TTL-form-input">
                            <el-input v-model="param.icon" placeholder="请输入组件icon名称" clearable />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <label class="TTL-form-label">菜单名称<i>*</i></label>
                        <div class="TTL-input width300 TTL-form-input">
                            <el-input v-model="param.menu_name" placeholder="请输入菜单名称" clearable />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <label class="TTL-form-label">组件名称<i>（菜单级需要填写，功能级不需要）</i></label>
                        <div class="TTL-input width300 TTL-form-input">
                            <el-input v-model="param.template" placeholder="请输入菜单名称" clearable />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <label class="TTL-form-label">功能名称标识<i>（菜单级不需要填写，功能级需要）</i></label>
                        <div class="TTL-input width300 TTL-form-input">
                            <el-input v-model="param.auth_name" placeholder="请输入功能名称标识" clearable />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <label class="TTL-form-label">排序</label>
                        <div class="TTL-input width300 TTL-form-input">
                            <el-input v-model="param.sort" placeholder="请输入菜单名称" clearable />
                        </div>
                    </el-form-item>
                    <el-form-item v-if="(param.id=='' && param.level==1) || (param.id > 0 && param.level==2)">
                        <label class="TTL-form-label">是否免费</label>
                        <div class="TTL-radio">
                            <el-radio-group v-model="param.isfree">
                                <el-radio label="0">免费</el-radio>
                                <el-radio label="1">收费（付费才可使用）</el-radio>
                                <el-radio label="2">收费（可使用，超出最大数据限制需付费）</el-radio>
                            </el-radio-group>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="param.isfree==1 || param.isfree==2">
                        <label class="TTL-form-label">默认收费金额</label>
                        <div class="TTL-input TTL-form-input TTL-append">
                            <el-input v-model="param.cost" placeholder="请填写默认收费金额" clearable>
                                <template #append>元 / 月</template>
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="(param.id==0 && param.level==2) || (param.id > 0 && param.level==3)">
                        <label class="TTL-form-label">访问方法名称</label>
                        <div class="TTL-input width300 TTL-form-input">
                            <el-input type="textarea" v-model="param.action" class="width350" :autosize="{ minRows: 6, maxRows: 8 }" />
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="TTL-page-box top40">
            <div class="TTL-page-box-in">
                <div class="TTL-page TTL-page-right">
                    <div class="TTL-button">
                        <el-button type="del" @click="param.show=false">取消</el-button>
                        <el-button @click="SubmitAuth">提交</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
export default {
    name: 'platFormMenu',
    data() {
        return {
            loadingobj: 'platformmenu',
            menus: [],
            param: {
                show: false,
                id: '',
                pid: 0,
                level: '',
                menu_name: '',
                icon: '',
                isfree: '0',
                template: '',
                auth_name: '',
                controller: '',
                action: '',
                cost: '',
                sort: '',
            },
        };
    },
    computed: {
        rootMenu() {
            return this.menus && this.menus.length ? this.menus[0] : null;
        },
        rootChildren() {
            return this.childList(this.rootMenu);
        },
    },
    mounted() {
        this.OnloadMethod();
    },
    methods: {
        OnloadMethod() {
            this.GetSysMenus();
        },
        BrotherComponentIn(data) {
            if (data.isask) {
                this.GetSysMenus();
            } else if (data.reload) {
            } else {
                this.GetSysMenus();
            }
        },
        childList(item) {
            return item && Array.isArray(item.children) ? item.children : [];
        },
        isPaid(item) {
            return item && (item.isfree == 1 || item.isfree == 2);
        },
        paidText(item) {
            if (!item) return '';
            if (item.isfree == 1) return '（付费使用，￥' + (item.cost || 0) + ' / 月）';
            if (item.isfree == 2) return '（免费使用，超出限制付费，￥' + (item.cost || 0) + ' / 月）';
            return '';
        },
        GetSysMenus() {
            var obj = this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHOP.GET_PLATFORM_MENUS().then((res) => {
                this.$loading.closeloading(obj);
                if (res.status > 0) return false;
                this.menus = res.data || [];
            });
        },
        addmeu(item) {
            this.resetParam();
            this.param.pid = item.id;
            this.param.level = item.level;
            this.param.show = true;
        },
        editmenus(item) {
            this.resetParam();
            this.param.show = true;
            this.param.id = item.id;
            this.param.pid = item.pid || 0;
            this.param.menu_name = item.name;
            this.param.icon = item.icon;
            this.param.isfree = String(item.isfree);
            this.param.template = item.template;
            this.param.auth_name = item.auth_name;
            this.param.controller = item.controller;
            this.param.action = item.action;
            this.param.sort = item.sort;
            this.param.level = item.level;
            this.param.cost = item.cost;
            if (this.param.level == 1 || this.param.level == 3) this.param.isfree = '0';
        },
        SubmitAuth() {
            if (!String(this.param.menu_name || '').trim()) {
                this.$notice({ title: '提示', message: '请输入菜单名称', type: 'warning' });
                return;
            }
            var obj = this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHOP.ADD_OR_EDIT_PLATFROM_MENU(this.param).then((res) => {
                this.$loading.closeloading(obj);
                if (res.status > 0) return false;
                this.param.show = false;
                this.GetSysMenus();
            });
        },
        resetParam() {
            this.param.show = false;
            this.param.id = '';
            this.param.pid = 0;
            this.param.menu_name = '';
            this.param.icon = '';
            this.param.isfree = '0';
            this.param.template = '';
            this.param.auth_name = '';
            this.param.controller = '';
            this.param.action = '';
            this.param.sort = '';
            this.param.cost = '';
            this.param.level = '';
        },
        delmenus(item) {
            this.$confirm.confirm(
                '该操作可能会引起账号使用异常，您是否确定要执行 ？',
                '操作提示',
                { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' },
            ).then(() => {
                INTERFACE_MODEL_SHOP.DEL_PLATFORM_MENUS({ id: item.id, level: item.level }).then((res) => {
                    if (res.status > 0) return false;
                    this.GetSysMenus();
                });
            }).catch(() => {});
        },
    },
};
</script>
<style scoped>
.TTL-title i {
    font-size: 12px;
    color: #e32626;
    font-style: normal;
    font-weight: normal;
}
.TTL-btn-option {
    display: inline-block;
    margin-right: 20px;
}
.permission-tree {
    padding: 10px 0;
}
.tree-level-1 {
    margin-bottom: 25px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fff;
}
.tree-level-1:last-child {
    margin-bottom: 0;
}
.level-1-header {
    padding: 12px 20px;
    background: #f5f7fa;
    border-bottom: 1px solid #e0e0e0;
}
.level-1-name {
    font-weight: bold;
    font-size: 14px;
    color: #333;
}
.tree-level-2-wrapper {
    padding: 15px 20px;
}
.tree-level-2 {
    margin-bottom: 22px;
    padding: 12px 15px;
    background: #fafafa;
    border-radius: 4px;
}
.tree-level-2:last-child {
    margin-bottom: 0;
}
.level-2-header {
    margin-bottom: 25px;
}
.level-2-name {
    font-weight: 600;
    font-size: 13px;
    color: #555;
}
.tree-level-3 {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 40px;
    padding-left: 8px;
}
.level-3-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.level-3-main,
.level-4-item,
.menu-row {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: auto;
    max-width: 100%;
}
.menu-row-main {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    gap: 10px;
}
.tree-level-4 {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 32px;
    padding-left: 12px;
}
.level-3-name,
.level-4-name {
    font-size: 13px;
    color: #666;
}
.level-1-name i,
.level-2-name i,
.level-3-name i,
.level-4-name i {
    font-style: normal;
    font-size: 12px;
    color: #e32626;
    font-weight: normal;
    margin-left: 6px;
}
.icon-box {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}
.icon-box .icon {
    width: 15px;
    height: 15px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    cursor: pointer;
}
.icon-box .add {
    background-image: url('@/assets/icon/add-black.png');
}
.icon-box .edit {
    background-image: url('@/assets/icon/edit-black.png');
}
.icon-box .del {
    background-image: url('@/assets/icon/del-black.png');
}
.TTL-form-label i {
    font-size: 12px;
    font-weight: normal;
}
.el-radio-group .el-radio {
    width: 100%;
}
</style>
